import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import InfoHint from '~/src/features/payments-abn/components/InfoHint';
import { BonusesPaymentForm } from '~/src/features/payments-abn/components/PaymentForms/components/BonusesPayment/BonusesPaymentForm';
import { useLoyaltyHint } from '~/src/features/payments-abn/components/SeasonTicketPayment/hooks/useLoyaltyHint';
import { EValidityStatus, setIsUseBonuses } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { updateBonusesAmount } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actions';
import WriteOffDetail, { IWriteOff } from '~/src/features/payments-abn/components/WriteOffDetail';
import { TState } from '~/src/store';

const LoyaltySection = ({ writeOffs }: { writeOffs: IWriteOff[]}): JSX.Element => {
    const dispatch = useDispatch();

    const { bonusesInfo, loyaltyBonuses } = useSelector((state: TState) => ({
        bonusesInfo: state.seasonTicketPayment.bonusesInfo,
        loyaltyBonuses: state.loyalty.info.bonuses,
    }), shallowEqual);
    const { isUseBonuses, amount, validity } = bonusesInfo;

    const loyaltyHintData = useLoyaltyHint();

    const onToggleHandler = () => {
        dispatch(setIsUseBonuses(!isUseBonuses));
    };

    const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const onlyNumbers = Number(event.target.value.replace(/\D/, ''));

        dispatch(updateBonusesAmount(+onlyNumbers));
    };

    return (
        <>
            <BonusesPaymentForm
                availableBonuses={loyaltyBonuses}
                value={amount}
                maxLength={`${loyaltyBonuses.toString().length}`}
                isChecked={isUseBonuses}
                isDisabled={!loyaltyBonuses}
                isValid={validity === EValidityStatus.IS_VALID && amount <= loyaltyBonuses}
                onToggle={onToggleHandler}
                onChange={onChangeHandler}
            />
            {isUseBonuses
                ? <>
                    {validity === EValidityStatus.IS_VALID && <WriteOffDetail writeOffs={writeOffs}/>}
                    {loyaltyHintData && <InfoHint {...loyaltyHintData}/>}
                </>
                : <WriteOffDetail writeOffs={writeOffs}/>
            }
        </>
    );
};

export default LoyaltySection;
